import { ActionScope } from "./ActionScope";
import { OrganizationLevel } from "./OrganizationLevel";
import { Participant } from "./Participant";

export class OrganizationParticipant extends Participant {
    name: string;
    actionScope: ActionScope;
    organizationLevel: OrganizationLevel;
    organizationId: string;
    organizationCode: string;
    organizationName: string;
    includeChildren: boolean;
    parentsUntil: boolean;
    tag: string;
}